<template>
    <div>
        <el-table :data="exportData.list">
            <el-table-column type="index" :label="$t('zhiji.knowlege.imExHistoryModal.order')" width="80" />
            <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.exportStatus')">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.task_status === 2"
                            >导出记录提示：导出成功实体组{{ scope.row.ext.entity_group_count }}条，实体名称{{ scope.row.ext.entity_words_count }}条。</span
                        >
                        <span v-else>{{ scope.row.task_error_info }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.exportEndTime')" width="180">
                <template slot-scope="scope">
                    <span v-if="scope.row.task_status === 0">{{ $t("zhiji.knowlege.imExHistoryModal.waiting") }}</span>
                    <span v-else-if="scope.row.task_status === 1"
                        >{{ scope.row.end_time }}({{ $t("zhiji.knowlege.imExHistoryModal.estimated") }})</span
                    >
                    <span v-else>{{ scope.row.update_time }}</span>
                </template>
            </el-table-column>
            <el-table-column property="operator" :label="$t('zhiji.knowlege.imExHistoryModal.operator')" width="100" />
            <el-table-column :label="$t('zhiji.knowlege.imExHistoryModal.operation')" width="130">
                <template slot-scope="scope">
                    <el-link v-if="scope.row.task_status === 2 && scope.row.file_url" type="primary" @click="downErrorData(scope.row.file_url)">{{
                        $t("zhiji.knowlege.imExHistoryModal.downloadForm")
                    }}</el-link>
                    <span v-if="scope.row.task_status === 3">{{ $t("zhiji.knowlege.imExHistoryModal.contact") }}</span>
                </template>
            </el-table-column>
        </el-table>
        <FooterPage :size="exportData.size" :total="exportData.total" :page="exportData.page" @sizeChange="sizeChange" @pageChange="pageChange" />
    </div>
</template>

<script>
import FooterPage from "@/views/zhiji/components/foot-page.vue";
import { exportEntityList } from "../server";

export default {
    name: "ExportStatus",
    components: {
        FooterPage
    },
    props: {
        status: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            exportData: {
                list: [],
                page: 1,
                size: 10,
                total: 1
            },
            language: ""
        };
    },
    watch: {
        status(modelStatus) {
            // eslint-disable-next-line no-unused-expressions
            modelStatus && this.getExportData();
        },
        "$i18n.locale": {
            handler(value) {
                this.language = value;
            },
            immediate: true
        }
    },
    mounted() {
        this.getExportData();
    },
    methods: {
        async getExportData() {
            const { list, count } = await exportEntityList({
                gameId: this.$store.state.zhiji.gameState.gameId,
                page: this.exportData.page,
                size: this.exportData.size
            });
            this.exportData.list = list;
            this.exportData.total = count;
        },
        sizeChange(newSize) {
            this.exportData.size = newSize;
            this.exportData.page = 1;
            this.getExportData();
        },
        pageChange(newPage) {
            this.exportData.page = newPage;
            this.getExportData();
        },
        // 下载导入错误信息表
        downErrorData(url) {
            window.open(url);
        }
    }
};
</script>
